// extracted by mini-css-extract-plugin
export default {"card":"ProfileCard_card__hIwa9","head":"ProfileCard_head__9cme3","title":"ProfileCard_title__Rf0gB","rule":"ProfileCard_rule__wBD3W"};